/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cmp_Page_Matrix_TitleInputs */

const en_mk_cmp_page_matrix_title = /** @type {(inputs: Mk_Cmp_Page_Matrix_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feature comparison`)
};

const id_mk_cmp_page_matrix_title = /** @type {(inputs: Mk_Cmp_Page_Matrix_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perbandingan fitur`)
};

/**
* | output |
* | --- |
* | "Feature comparison" |
*
* @param {Mk_Cmp_Page_Matrix_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cmp_page_matrix_title = /** @type {((inputs?: Mk_Cmp_Page_Matrix_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cmp_Page_Matrix_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cmp_page_matrix_title(inputs)
	return en_mk_cmp_page_matrix_title(inputs)
});